const { ICONS_METHODS } = require('../../../../../constants/commons');

const shouldRenderSecurityCode = (pm) => !!pm?.security_code;

const shouldRenderInstallments = (pm) => pm?.installments?.length !== 0 && !!pm?.show_installments;

const shouldRenderCollapsedContent = ({ paymentMethod, express, selectedMethod, hasCCAPTokenizationFlagEnabled }) => {
    const cardToken = express?.[paymentMethod?.option_id]?.cardTokenId;
    const renderInstallments = shouldRenderInstallments(paymentMethod);
    const canRenderCollapsed = hasCCAPTokenizationFlagEnabled ? selectedMethod?.option_id === paymentMethod?.option_id : true;

    if (!canRenderCollapsed) {
        return false;
    }

    if (cardToken) {
        return renderInstallments;
    }

    return shouldRenderSecurityCode(paymentMethod) || renderInstallments;
};

const getPaymentMethodId = (paymentMethod, rebrandingMP) => {
    if (rebrandingMP) {
      if (paymentMethod?.id === ICONS_METHODS.ICON_ACCOUNT_MONEY_BLACK) {
        return ICONS_METHODS.ICON_ACCOUNT_MONEY_YELLOW;
      }
  
      if (paymentMethod?.id === ICONS_METHODS.ICON_CONSUMER_CREDITS) {
        return ICONS_METHODS.ICON_MERCADO_CREDITO_YELLOW;
      }
    }
  
    return paymentMethod?.id;
};

const canRenderSmartTokenizationInput = ({
  paymentMethod,
  hasCCAPTokenizationFlagEnabled,
  smartTokenizationContext,
}) =>
  shouldRenderSecurityCode(paymentMethod) &&
  hasCCAPTokenizationFlagEnabled &&
  smartTokenizationContext?.meliSessionId;


module.exports = {
    shouldRenderSecurityCode,
    shouldRenderInstallments,
    shouldRenderCollapsedContent,
    getPaymentMethodId,
    canRenderSmartTokenizationInput
};